// extracted by mini-css-extract-plugin
export default {"letteredUserCircleContainer":"letteredUserCircle_letteredUserCircleContainer__yhKC7","isClickable":"letteredUserCircle_isClickable__rY3OC"};